<script setup lang="ts">
    const props = defineProps<{
        modelValue: string
        label?: string
        name?: string
    }>()

    const emit = defineEmits<{
        'update:modelValue': [string]
    }>()

    const modelValue = computed({
        get: () => props.modelValue,
        set: (value: string) => {
            emit('update:modelValue', value)
        },
    })
</script>

<template>
    <div>
        <VvInputText
            v-model="modelValue"
            class="pk-input-color"
            :name="name"
            type="color"
            icon="ri:sip-line"
            icon-position="after"
            :label="label" />
    </div>
</template>

<style lang="scss">
    .pk-input-color {
        .vv-input-text__icon-after {
            width: var(--spacing-18);
            height: var(--spacing-18);
            border-radius: 100%;
            position: absolute;

            // Centred in the field for any height; the 12px from the border
            // come from the icon margin of the field tokens, so `right` stays
            // at zero or the icon lands on the swatch
            top: calc((var(--input-min-height) - var(--spacing-18)) / 2);
            right: 0;
        }
    }
</style>
